module.exports = __webpack_public_path__ + "static/media/rememberthetitans.ced3d0ea.jpeg";